import {ConfigService, ModelsList, StoreService, Ticket, TicketsComments, TicketsComment} from 'shared';
import {Observable} from 'rxjs';
import {HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ErrorsService} from 'shared';

@Injectable({
  deps: [HttpClient],
  providedIn: 'root'
})
export class SupportService extends StoreService<Ticket> {


  constructor(http: HttpClient, config: ConfigService, errors: ErrorsService) {
    super(http, config, errors);
    this.initStore(Ticket);
  }

  protected load(queryParams?: HttpParams): Observable<ModelsList<Ticket>> {
    return this.http.get<ModelsList<Ticket>>(this.config.apiVerUrl('/app/tickets'), {params: queryParams});
  }

  protected remove(id): Observable<void> {
    return this.http.delete<void>(this.config.apiVerUrl(`/app/tickets/${id}`));
  }

  protected insert(values: Ticket): Observable<number> {
    return this.http.post<number>(this.config.apiVerUrl('/app/tickets'), values);
  }

  public update(id, values): Observable<Ticket> {
    return this.http.put<Ticket>(this.config.apiVerUrl(`/app/tickets/${id}`), values);
  }

  public comments(id): Observable<TicketsComments> {
    return this.http.get<TicketsComments>(this.config.apiVerUrl(`/app/tickets/${id}/comments`));
  }

  public addComment(values): Observable<TicketsComment> {
    return this.http.post<TicketsComment>(this.config.apiVerUrl(`/app/tickets/comments/add`), values);
  }
}
